<template>
	<div class="v-form-public">
		<div class="form__heading">
			<h2 class="form__title">{{subscriptionsYourDetails}}</h2>
		</div>

		<ul class="form__list">
			<li class="form__item">
			<v-textfield-public 
				:label="usersCompanyName" 
				name="company[company_name]" 
				v-validate="`alpha_num_spaces`">
			</v-textfield-public>
			</li>
			<li class="form__item form__item--no-label">
			<v-radios-public 
				name="title_id"
				:options="usersSex"
				:rules="`required|make_choice`">
			</v-radios-public>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="usersFirstName + ' (*)'" 
				name="first_name" 
				v-validate="`required|alpha_spaces_dash`">
			</v-textfield-public>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="usersMiddleName" 
				name="middle_name">
			</v-textfield-public>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="usersLastName + ' (*)'" 
				name="last_name" 
				v-validate="`required|alpha_spaces_dash`">
			</v-textfield-public>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="usersPhoneNumber + ' (*)'" 
				name="phone_number" 
				v-validate="`required|phone_number`">
			</v-textfield-public>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="usersEmail + ' (*)'" 
				name="email" 
				v-validate="`required|email`" 
				@blur="checkMail">
			</v-textfield-public>
			</li>
			<li class="form__item" v-if="!!is_user_already_exists">
				<label class="form__label"></label><b style="color: red;">{{userAlreadyExists}}</b>
				<input type="hidden" name="user_already_exists" v-validate="`required`">
			</li>      
		</ul>
		<div class="form__heading">
			<h2 class="form__title">{{propDetails}}</h2>
		</div>

		<ul class="form__list">
			<li class="form__item">
			<v-textfield-public 
				:label="propPostCode + ' (*)'" 
				name="postcode" 
				v-validate="`required|post_code`">
			</v-textfield-public>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-textfield-public 
							:label="propBuildingUid + ' (*)'" 
							name="building_uid" 
							v-validate="`required`">
						</v-textfield-public>
					</div>
					<div class="form__column">
						<v-textfield-public 
							:label="propBuildingUidApp" 
							name="building_uid_appendix">
						</v-textfield-public>
					</div>
				</div>
			</li>
			<li class="form__item">
			<v-textfield-public 
				:label="propStreet + ' (*)'" 
				name="street" 
				v-validate="`required|alpha_num_spaces`">
			</v-textfield-public>
			</li>
			<li class="form__item">
			<v-autocomplete-public
				name='location_id'
				:label="propLocation + ' (*)'"
				endpoint="/admin/autocomplete/locations"
				:resolve="(item) => item.name"
				v-validate="`required|location`">
			</v-autocomplete-public>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-datepicker-public 
							:label="propAvailableFrom + ' (*)'" 
							name="available_from" 
							v-validate="`required`">
						</v-datepicker-public>
					</div>
					<div class="form__column">
						<v-datepicker-public 
							:label="propAvailableUntil" 
							name="available_until">
						</v-datepicker-public>
					</div>
				</div>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-textfield-public 
							:label="propDesiredRentalPrice" 
							type="number" 
							:name="propDesiredRentalPriceName" 
							:placeholder="'€ ' + propMonth">
						</v-textfield-public>
					</div>
					<div class="form__column">
						<v-textfield-public 
							:label="propMaxNumber" 
							type="number" 
							name="max_people" 
							:placeholder="propMaxNumberPlaceholder">
						</v-textfield-public>
					</div>
				</div>
			</li>
      <!-- <li class="form__item">
          <div class="form__row">
              <div class="form__column btn">
                  <a class="form__button"
                      :href="calculatePriceLink"
                      target="_blank">{{ locales && locales.properties && locales.properties.calculate_property_rent_price }}</a>
              </div>
          </div>
      </li> -->
			<li class="form__item">
				<div class="form__field-box">
					<label class="form__label form__label-media">
						{{propPriceIncludes}}
					</label> 
					<div class="v-checkbox">
						<template v-for="item in checkBoxArray">
							<input 
								type='hidden' 
								:name="propServicesName + `[` + item + `]`" 
								value="0">
							<v-checkboxes 
								:value="propServicesValue" 
								:name="propServicesName + `[` + item + `]`" 
								:options="{1:locales && locales.properties && locales.properties[item]}">
							</v-checkboxes>
						</template>
					</div>
				</div>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-select-public 
							:label="propType" 
							name="type_id" 
							value="0" 
							:zero-option="propUnknown"
							:options="propTypeOpt" 
							v-validate="`required`">
						</v-select-public>
					</div>
					<div class="form__column">
						<v-select-public 
							:label="propInterior" 
							name="furnishing_id" 
							value="0" 
							:zero-option="propUnknown"
							:options="propInteriorOpt" 
							v-validate="`required`">
						</v-select-public>
					</div>
				</div>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-textfield-public 
							:label="propBedrooms" 
							type="number" 
							name="no_bedrooms" 
							:placeholder="propRooms">
						</v-textfield-public>
					</div>
					<div class="form__column">
						<v-textfield-public 
							:label="propSurface" 
							type="number" 
							name="area" 
							placeholder="m2">
						</v-textfield-public>
					</div>
				</div>
			</li>
			<li class="form__item">
				<div class="form__row">
					<div class="form__column">
						<v-textfield-public 
							:label="propParkingPlaces" 
							type="number" 
							name="no_parking_places" 
							:placeholder="propPlaces">
						</v-textfield-public>
					</div>
					<div class="form__column">
						<v-select-public 
							:label-html="subscriptionsParkingPlace" 
							name="parking_type_id" 
							value="0"
							:zero-option="propUnknown" 
							:options="subscriptionsParkingPlaceOpt">
						</v-select-public>
					</div>
				</div>
			</li>
		</ul>
		<ul class="form__list">
			<li class="form__item">
				<label class="form__label">
					{{propOtherInformation}}
				</label>
				<textarea 
					class="form__textarea" 
					name="description_trans[nl]">
				</textarea>
			</li>
		</ul>
		<div class="form__heading">
			<h2 class="form__title">{{propPhotos}}</h2>
		</div>
		<p><strong>{{propImageUploadText}}</strong></p>
		<ul class="form__list">
			<li class="form__item">
				<input type="file" name='photos[]' accept="image/*" multiple>
			</li>
		</ul>
		<i>{{propImageUploadTip}}</i>
		<ul class="form__list">
			<li class="form__item form__item--align-start">
				<v-checkboxes-public 
					:label-html="confirmTermsOfUse"
					:options="{'1':''}"
					class="form__radio" 
					:rules="`required`">
				</v-checkboxes-public>
			</li>
			<li v-if="isRecaptcha === 'true'" class="form__item">
				<v-recaptcha @validate="checkRecaptcha" :site-key="recaptchaKey"></v-recaptcha>
			</li>
			<li v-if="buttonAlign == 'left'" class="form__item" style="justify-content: flex-start;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
			<li v-else class="form__item" style="justify-content: flex-end;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import VTextfieldPublic from "./VTextfieldPublic";
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
	inject: ['$validator'],
	components: {
		VTextfieldPublic
	},
	data () {
		return {
			is_user_already_exists: 0,
			no_bathrooms: 0,
			is_garden_present: [0, 0],
			is_balcony_present: [0, 0],
			is_terrace_present: [0, 0],
			recaptchaTicked: false,
		}
	},
	computed: {
		...mapGetters(["locales"]),
		number_of_bathrooms_value_computed: function () {
			if (this.no_bathrooms >= 1) {
				return this.no_bathrooms;
			} else {
				return 0;
			}
		}
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		subscriptionsYourDetails: {
			default: '',
			type: String
		},
		usersCompanyName: {
			default: '',
			type: String
		},
		usersSex: {
			default: () => {},
			type: Object
		},
		usersFirstName: {
			default: '',
			type: String
		},
		usersMiddleName: {
			default: '',
			type: String
		},
		usersLastName: {
			default: '',
			type: String
		},
		usersPhoneNumber: {
			default: '',
			type: String
		},
		usersEmail: {
			default: '',
			type: String
    },
    usersBankAccount: {
			default: '',
			type: String
    },
    usersBic: {
			default: '',
			type: String
		},
		userAlreadyExists: {
			default: '',
			type: String
		},
		propDetails: {
			default: '',
			type: String
		},
		propPostCode: {
			default: '',
			type: String
		},
		propBuildingUid: {
			default: '',
			type: String
		},
		propBuildingUidApp: {
			default: '',
			type: String
		},
		propStreet: {
			default: '',
			type: String
		},
		propLocation: {
			default: '',
			type: String
		},
		propAvailableFrom: {
			default: '',
			type: String
		},
		propAvailableUntil: {
			default: '',
			type: String
		},
		propDesiredRentalPrice: {
			default: '',
			type: String
		},
		propDesiredRentalPriceName: {
			default: '',
			type: String
		},
		propMonth: {
			default: '',
			type: String
		},
		propMaxNumber: {
			default: '',
			type: String
		},
		propMaxNumberPlaceholder: {
			default: '',
			type: String
		},
		propPriceIncludes: {
			default: '',
			type: String
		},
		propServicesName: {
			default: '',
			type: String
		},
		propServicesValue: {
			default: '',
			type: String
		},
		propType: {
			default: '',
			type: String
		},
		propUnknown: {
			default: '',
			type: String
		},
		propTypeOpt: {
			default: () => {},
			type: Object
		},
		propInterior: {
			default: '',
			type: String
		},
		propInteriorOpt: {
			default: () => {},
			type: Object
		},
		propBedrooms: {
			default: '',
			type: String
		},
		propRooms: {
			default: '',
			type: String
		},
		propSurface: {
			default: '',
			type: String
		},
		propParkingPlaces: {
			default: '',
			type: String
		},
		propPlaces: {
			default: '',
			type: String
		},
		subscriptionsParkingPlace: {
			default: '',
			type: String
		},
		subscriptionsParkingPlaceOpt: {
			default: () => {},
			type: Object
		},
		propOtherInformation: {
			default: '',
			type: String
		},
		propPhotos: {
			default: '',
			type: String
		},
		propImageUploadText: {
			default: '',
			type: String
		},
		propImageUploadTip: {
			default: '',
			type: String
		},
		confirmTermsOfUse: {
			default: '',
			type: String
		},
		checkBoxArray: {
			default: () => [],
			type: Array
    },
    calculatePriceLink: {
			default: '',
			type: String
		},
	},
	methods: {
		checkMail: function (event) {
			var email = event.target.value;
			if (email == '')
				return this.is_user_already_exists = 0;
			var vm = this;
			$.ajax({
				url: `/api/users/check-mail`,
				method: 'post',
				data: {
					email: email
				},
				success: function (result) {
					vm.is_user_already_exists = +result;
				},
				error: function () {
				}
			});
		},
		bathroomsUpdate: function (value) {
			this.no_bathrooms = +value;
		},
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						return;
					}
				} 
				if (res) {
					let form = $('#form');
					let data = $('form').serialize();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess){
						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							success: function (result) {
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								if(result.responseJSON.url!==undefined){
									if(errorMessage!==''){
										sweetalert(window.app.locales.common.error,errorMessage, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}else{
										sweetalert(window.app.locales.common.error,window.app.locales.common.error, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}
								}
							}
						});
					}else{
						form.submit();
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VLetShForm.vue